var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[_c('b-table',_vm._b({attrs:{"outlined":""},on:{"row-clicked":function($event){return _vm.$emit('select', $event)}},scopedSlots:_vm._u([{key:"table-colgroup",fn:function(ref){
var fields = ref.fields;
return _vm._l((fields),function(f){return _c('col',{key:f.key,class:("col-" + (f.key))})})}},{key:"status",fn:function(ref){
var item = ref.item;
var value = ref.value;
return [_c('TaskStatus',{staticClass:"cursor-pointer",staticStyle:{"margin":"-0.6rem"},attrs:{"type":value}})]}},{key:"date",fn:function(ref){
var value = ref.value;
return [_vm._v("\n      "+_vm._s(_vm.formatDate(value))+"\n    ")]}}])},'b-table',{ fields: _vm.fields, items: _vm.items },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }